import { EActionStatus } from 'legacy/lut/classes/models/onboarding/Onboarding'

/**
 * Step data (forms, collected files) is editable while the action is in progress
 * and when it failed — an errored action usually needs its data fixed before retry.
 */
export const isActionDataEditable = (status?: string): boolean =>
  status === EActionStatus.WIP || status === EActionStatus.Error
